// extracted by mini-css-extract-plugin
export default {"section":"InvitePassword_section__40W4A","form":"InvitePassword_form__cgDKb"};